import {Checkbox} from "antd";
import React from "react";

const SUBGROUPS_AMOUNT = 2;

const SubgroupFilters = ({subgroupFilters, setFilter}) => {

    const selectSubgroupHandler = (value, index) => {
        const tmp = [...subgroupFilters];
        tmp[index] = value.target.checked;
        setFilter(tmp, "subgroupFilters");
    }

    const subgroupFiltersArray = [];
    for (let i = 0; i < SUBGROUPS_AMOUNT; i++) {
        subgroupFiltersArray.push(
            <Checkbox
                key={`subgroup${i}`}
                checked={subgroupFilters[i]}
                onChange={(e) => selectSubgroupHandler(e, i)}>
                {i + 1}
            </Checkbox>);
    }

    return subgroupFiltersArray;
}

export default SubgroupFilters;